import React, { useState } from "react";
import {
  ColumnDef,
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  SortingState,
  useReactTable,
} from "@tanstack/react-table";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
type ButtonsDto = {
  isShowBtn?: Boolean;
  btnTitle?: string;
  btnAction: (d: string) => void;
  btnActionType?: number;
};
interface AdvancedDataTableProps<T extends object> {
  data: T[];
  columns: ColumnDef<T>[];
  isLoading?: boolean;
  title: string;
  Buttons?: ButtonsDto[];
  idName?: string;
  btnActionType?: number;
  isShowExportExcel?: Boolean;
  isShowCountRecords?: Boolean;
  isShowSearch?: Boolean;
  isShowPaging?: Boolean;
}

export default function AdvancedDataTable<T extends object>({
  data,
  columns,
  isLoading = false,
  title,
  isShowExportExcel,
  isShowPaging = true,
  isShowSearch = true,
  isShowCountRecords,
  btnActionType = 1,
  idName = "catId",
  Buttons,
}: AdvancedDataTableProps<T>) {
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<SortingState>([]);

  const table = useReactTable({
    data,
    columns,
    state: {
      globalFilter,
      sorting,
    },
    onGlobalFilterChange: setGlobalFilter,
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  // const exportExcel = () => {
  //   const rows = table.getFilteredRowModel().rows.map((row) => row.original);

  //   const worksheet = XLSX.utils.json_to_sheet(rows);

  //   const workbook = XLSX.utils.book_new();

  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

  //   const excelBuffer = XLSX.write(workbook, {
  //     bookType: "xlsx",
  //     type: "array",
  //   });

  //   const file = new Blob([excelBuffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });

  //   saveAs(file, "export.xlsx");
  // };
 const exportExcel = () => {

  const exportData = table
    .getFilteredRowModel()
    .rows.map((row) => {

      const item: Record<string, any> = {};

      table.getAllColumns().forEach((column) => {

        // استبعاد عمود المعرف
        if (column.id === idName) return;

        const header =
          typeof column.columnDef.header === "string"
            ? column.columnDef.header
            : column.id;

        item[header] = row.getValue(column.id);
      });

      return item;
    });

  const worksheet =
    XLSX.utils.json_to_sheet(exportData);

  const workbook =
    XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "Data"
  );

  const excelBuffer = XLSX.write(
    workbook,
    {
      bookType: "xlsx",
      type: "array",
    }
  );

  const file = new Blob(
    [excelBuffer],
    {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }
  );

  saveAs(file, "export.xlsx");
};

  return (
    <div className="p-4">
      <h1>{title} </h1>
      {/* Toolbar */}
      <div
        style={{
          display: "flex",
          gap: "10px",
          marginBottom: "20px",
          alignItems: "center",
        }}
        
      >
        {isShowSearch && (
          <input
            placeholder="بحث...."
            value={globalFilter}
            onChange={(e) => setGlobalFilter(e.target.value)}
            style={{
              padding: "8px",
              border: "1px solid #ccc",
            }}
          />
        )}

        {isShowPaging && (
          <select
            value={table.getState().pagination.pageSize}
            onChange={(e) => table.setPageSize(Number(e.target.value))}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        )}
        {isShowExportExcel && (
            <button onClick={exportExcel} className="flex items-center gap-2 px-6 py-3 bg-surface text-primary border-2 border-primary/20 hover:bg-primary/5 rounded-full transition-all group">
                <span className="material-symbols-outlined text-[20px] transition-transform group-hover:-translate-y-1">
                  download
                </span>
                <span className="font-label-md text-label-md">
                  تصدير التقرير
                </span>
              </button> 
             
        )}
        {isShowCountRecords && (
          <b>
            عدد السجلات:
            {table.getFilteredRowModel().rows.length}
          </b>
        )}
      </div>

      {/* Table */}
      <div style={{ overflowX: "auto" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            {table.getHeaderGroups().map((group) => (
              <tr key={group.id}>
                <th
                  style={{
                    border: "1px solid #ddd",
                    padding: "12px",
                    background: "#f8f8f8",
                    cursor: "pointer",
                  }}
                >
                  #
                </th>
                {group.headers.map((header) => (
                  (header.column.id!==idName)?(
                  <th
                    key={header.id}
                    onClick={header.column.getToggleSortingHandler()}
                    style={{
                      border: "1px solid #ddd",
                      padding: "12px",
                      background: "#f8f8f8",
                      cursor: "pointer",
                    }}
                  > 
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext(),
                    )}
                     
                    {header.column.getIsSorted() === "asc" && " 🔼"}

                    {header.column.getIsSorted() === "desc" && " 🔽"}
                  </th>):null
                ))}
                 
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "12px",
                      background: "#f8f8f8",
                      cursor: "pointer",
                    }}
                  >
                    الإجراءات
                  </th> 
              </tr>
            ))}
          </thead>

          <tbody>
            {isLoading ? (
              <tr>
                <td
                  colSpan={columns.length}
                  style={{
                    textAlign: "center",
                    padding: "20px",
                  }}
                >
                  Loading...
                </td>
              </tr>
            ) : table.getRowModel().rows.length === 0 ? (
              <tr>
                <td
                  colSpan={columns.length}
                  style={{
                    textAlign: "center",
                    padding: "20px",
                  }}
                >
                  لايوجد بيانات
                </td>
              </tr>
            ) : (
              table.getRowModel().rows.map((row) => (
                <tr key={row.id}>
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: "10px",
                    }}
                  >
                    {row.index + 1}
                  </td>
                  {row.getVisibleCells().map((cell) => (
                     (cell.column.id!==idName)?(
                    <td
                      key={cell.id}
                      style={{
                        border: "1px solid #ddd",
                        padding: "10px",
                      }}
                    > 
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext(),
                      )}
                    </td>):null
                  ))} 
                    <td
                      style={{
                        border: "1px solid #ddd",
                        padding: "10px",
                      }}
                    >
                      
                      {Buttons?.map((d, index) => (
                        <button
                          key={index}
                           className={
                          "rounded-full shadow-sm  " +
                          (d.btnActionType === 1
                            ? "bg-primary text-on-primary hover:bg-primary/90"
                            : "bg-error text-on-error hover:bg-error/90") +
                          " font-label-md px-6 py-2  transition-al"
                        }
                          onClick={() => {
                            const catId = row.getValue<string>(idName);
                            d.btnAction(catId);
                          }}
                        >
                          {d.btnTitle}
                        </button>
                      ))}
                    </td> 
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Footer */}
      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
          marginTop: "20px",
        }}
      >
        <button
          onClick={() => table.firstPage()}
          disabled={!table.getCanPreviousPage()}
        >
          First
        </button>

        <button
          onClick={() => table.previousPage()}
          disabled={!table.getCanPreviousPage()}
        >
          Previous
        </button>

        <span>
          Page {table.getState().pagination.pageIndex + 1}
          {" / "}
          {table.getPageCount()}
        </span>

        <button
          onClick={() => table.nextPage()}
          disabled={!table.getCanNextPage()}
        >
          Next
        </button>

        <button
          onClick={() => table.lastPage()}
          disabled={!table.getCanNextPage()}
        >
          Last
        </button>
      </div>
    </div>
  );
}
